import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export abstract class BaseService<T> {

  tipo: string;
  urlBase: string;

  constructor(protected httpClient: HttpClient) { }

    getAll(): Observable<T[]>{
      const op = `Obtener todos los registros del tipo ${this.tipo}`;
      return this.httpClient.get<T[]>(this.urlBase);
    }

    get(_id: string): Observable<T> {
      const op = `Obtener registro del tipo ${this.tipo} con _id ${_id}`;

      return this.httpClient.get<T>(`${this.urlBase}/${_id}`);
    }

    save(t: T): Observable<T> {
      const op = `Creación registro del tipo ${this.tipo} `;

      return this.httpClient.post<T>(this.urlBase, t);
    }

    update(t: T): Observable<T> {
      const op = `Actualización del registro del tipo ${this.tipo} `;

      return this.httpClient.put<T>(this.urlBase, t);
    }

    delete(_id: string): Observable<any> {
      const op = `Eliminación del registro del tipo ${this.tipo}, _id  ${_id}`;
      return this.httpClient.delete<any>(`${this.urlBase}/${_id}`);
    }
}
